import i18n from '@/i18n';
import { checkRoleKey, ModuleKey, Role as NxtRole, RoleKey } from '@nxtpeople/nxt-vue-library';
import { NavigationGuard } from 'vue-router';
import { isUserInfoReady } from '../collections/contracts-api/user-info/user-info.helper';
import store from '../store';

export interface Role extends Omit<NxtRole, 'key'> {
   key: RoleKey;
   name: string;
   description: string;
}

export function checkRole(roleKey: RoleKey) {
   return checkRoleKey(roleKey, ModuleKey.NxtPay, store.state.userInfo?.userInfo?.roles || []);
}

const ROLE_GUARD = (requiredRole: RoleKey): NavigationGuard => {
   return async (to, from, next) => {
      await isUserInfoReady();

      const roles = (store.state.userInfo?.userInfo?.roles || []) as Array<Role>;

      const hasRole = checkRoleKey(requiredRole, ModuleKey.NxtPay, roles);

      if (hasRole) return next();

      notifyError({ title: i18n.global.t('generic.access-denied') });
      return next('/');
   };
};

export default ROLE_GUARD;
